var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssessmentsStats({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 2H6.25C5.71957 2 5.21086 2.21071 4.83579 2.58579C4.46071 2.96086 4.25 3.46957 4.25 4V20C4.25 20.5304 4.46071 21.0391 4.83579 21.4142C5.21086 21.7893 5.71957 22 6.25 22H18.25C18.7804 22 19.2891 21.7893 19.6642 21.4142C20.0393 21.0391 20.25 20.5304 20.25 20V8L14.25 2Z",
    stroke: "#121216",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 2V8H20.25",
    stroke: "#121216",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 13H8.25",
    stroke: "#121216",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 17H8.25",
    stroke: "#121216",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 9H9.25H8.25",
    stroke: "#121216",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessmentsStats);
export default __webpack_public_path__ + "static/media/assessments-stats.824d2354ebc3a6b583e07f4ca47cf6ae.svg";
export { ForwardRef as ReactComponent };